import AbstractService from "./Abstract.service";

export default class LothunService extends AbstractService
{
    listing(date:String): Promise<any>
    {
        return this.get(`/lotok/hun?date=${date}`);
    }

    listing_zone(): Promise<any>
    {
        return this.get(`/zone`);
    }

    listing_date(zone:String): Promise<any>
    {
        return this.get(`/lotok/zone/all/${zone}`);
    }

    listing_billing(p_ok_id:String,p_mcut:String,p_namecut:String,p_mset:String,p_lot_zone:String): Promise<any>
    {
        return this.get(`/moeny/lotto?p_ok_id=${p_ok_id}&p_mcut=${p_mcut}&p_mset=${p_mset}&p_namecut=${p_namecut}&p_lot_zone=${p_lot_zone}`);
    }

    process_reset(payload:Object): Promise<any>
    {
        return this.post(`/rebill`,payload);
    }

    process_save(payload:Object): Promise<any>
    {
        return this.post(`/lotok/result`,payload);
    }

    process_ok(payload:Object): Promise<any>
    {
        return this.post(`/process`,payload);
    }

    process_mn(payload:Object): Promise<any>
    {
        return this.post(`/process/pro-mn`,payload);
    }

    process_control(payload:Object): Promise<any>
    {
        return this.post(`/control`,payload);
    }

    listing_details(p_ok_id:String,p_mset:String,p_lot_zone:String,p_number:String,p_lot_type:String): Promise<any>
    {
        return this.get(`/moeny/lotto/user?p_ok_id=${p_ok_id}&p_mset=${p_mset}&p_lot_zone=${p_lot_zone}&p_number=${p_number}&p_lot_type=${p_lot_type}`);
    }
}
